import { WorkerPoolContextProvider } from "@pierre/diffs/react";
import DiffsWorker from "@pierre/diffs/worker/worker.js?worker";
import type { FC, ReactNode } from "react";

/**
 * Wraps children in a @pierre/diffs WorkerPoolContextProvider.
 * Skips the provider when Worker is unavailable (e.g. happy-dom tests)
 * to avoid ReferenceError on eager pool initialization.
 */
export const DiffsPoolProvider: FC<{ children: ReactNode }> = ({ children }) => {
    if (typeof Worker === "undefined") {
        return <>{children}</>;
    }
    return (
        <WorkerPoolContextProvider poolOptions={{ workerFactory: () => new DiffsWorker() }} highlighterOptions={{}}>
            {children}
        </WorkerPoolContextProvider>
    );
};
